import React from "react";

const ProjectCard = ({ item }) => {
    const { name, details, link, cover } = item;

    const onClick = () => {
        window.open(link, "_blank");
    };

    return (
        <div className={`bg-blue20 rounded-lg flex flex-col text-left w-[350px] h-[380px]`}>
            <div className="h-1/2 bg-[#000] cursor-pointer" onClick={onClick}>
                <img
                    src={cover}
                    alt="project_cover"
                    className="object-contain w-full h-full opacity-50 hover:opacity-100 transition ease-in-out"
                />
            </div>
            <div className={`border-t-2 border-secondary h-1/2`}>
                <div className="flex flex-col p-4">
                    <div className="my-2 mb-4">
                        <h4 className="text-xl text-white">{name}</h4>
                    </div>
                    <p className="text-sm text-light">{details}</p>
                    <div className="mt-4 mb-4">
                        <button
                            onClick={onClick}
                            className="border-4 bg-transparent border-blue30 rounded-lg p-1 text-white hover:text-secondarylight hover:bg-blue20  transition ease-in-out"
                        >
                            <span className="mx-4 font-medium text-sm">Check it out</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProjectCard;
